enum MaxScreenSizes {
  sm = 640,
  md = 769,
  lg = 1025,
  xl = 1281,
  xxl = 1441,
  xxxl = 1728,
}

interface Sizes {
  sm: string;
  md: string;
  lg: string;
  xl: string;
  xxl: string;
  xxxl: string;
}

const sizes: Sizes = {
  sm: `${MaxScreenSizes.sm}px`,
  md: `${MaxScreenSizes.md}px`,
  lg: `${MaxScreenSizes.lg}px`,
  xl: `${MaxScreenSizes.xl}px`,
  xxl: `${MaxScreenSizes.xxl}px`,
  xxxl: `${MaxScreenSizes.xxxl}px`,
};

export const isBrowser = () => typeof window !== 'undefined';

export const isMobile = () => isBrowser() && Math.min(window.screen.width, window.screen.height) <= MaxScreenSizes.md;

interface DeviceIsArgs {
  mobile: any;
  desktop: any;
}

export const deviceIs = ({ mobile, desktop }: DeviceIsArgs) => (isMobile() ? mobile : desktop);

export const device = {
  sm: `(max-width: ${sizes.sm})`, // <= 640px
  md: `(min-width: ${sizes.sm})`, // 640px - 768px
  mdOnly: `(min-width: ${sizes.sm}) and (max-width: ${sizes.md})`, // 640px - 768px
  lg: `(min-width: ${sizes.md})`, // 768px - 1024px
  xl: `(min-width: ${sizes.lg})`, // 1024px - 1280px
  xxl: `(min-width: ${sizes.xl})`, // 1280px - 1440px
  xxxl: `(min-width: ${sizes.xxl})`, //  1440px - 1728px
  xxxxl: `(min-width: ${sizes.xxxl})`, // > 1728px
};
